export const SET_LEX_LANG_LAUNCH = 'SET_LEX_LANG_LAUNCH';

export const SET_LEX_CARD_HT = 'SET_LEX_CARD_HT';

export const SET_LEX_CARD_ID = 'SET_LEX_CARD_ID';

export const SET_LEX_TAB = 'SET_LEX_TAB';

export const SET_BR_WIDTH = 'SET_BR_WIDTH';

export const SET_LEX_EXPAND_REQ_OBJ = 'SET_LEX_EXPAND_REQ_OBJ';

export const SET_LEX_CARD_BL_HT = 'SET_LEX_CARD_BL_HT';

export const SET_LEX_REQ_OBJ = 'SET_LEX_REQ_OBJ';

export const SET_LEX_EXP_CARD = 'SET_LEX_EXP_CARD';

export const SET_LP_DATA_FOR_CORUSE_LAUNCH = 'SET_LP_DATA_FOR_CORUSE_LAUNCH';

